import type { ReactNode } from 'react';
import { Label } from './label.js';

/**
 * Wiederverwendbarer Form-Field-Wrapper: Label + Children + optionaler
 * Fehlertext. Wird in Onboarding-Forms massiv genutzt, deshalb hier
 * zentral statt pro Page wiederholen.
 */
export function Field({
  label,
  htmlFor,
  error,
  hint,
  children,
}: {
  label: string;
  htmlFor: string;
  error?: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={htmlFor}>{label}</Label>
      {children}
      {hint && !error && <p className="text-xs text-[var(--muted-foreground)]">{hint}</p>}
      {error && <p className="text-xs text-[oklch(0.55_0.2_25)]">{error}</p>}
    </div>
  );
}
